<template>
  <a-layout class='index animated fadeIn theme_bg_color p-25'>
    <p class="s_font_b fz-30 text-ac m-b-20">应用服务中心</p>
    <p class="text-ac s_mauto width80 fz-16">高大永恒塑料制品有限公司立足于服务品牌企业，利用数字化技术（大数据、云计算、人工智能等）来推动品牌企业商业模式、业务创新，营销传播，组织架构等方面的重塑，通过原生
      线下场景的大数据抓取、数据模型提炼，提升企业对数据的处理能力，提升效率，从而增加企业的经营效能。</p>
    <!-- base_border -->
    <div class="m-t-25">
      <a-spin :spinning="listLoading">
         <div class="p-25 s_bf4f s_bor10 s_flex_bian_c m-b-30"  v-if="is_getFun()">
            <div class="width74 s_flex_ali scroll-view" style="overflow:auto">
              <div  v-for='(item,index) in list' :key='index' class="s_flex_center s_flex_fdc m-r-30" v-show="item.is_get==1">
                <img class='width-100 height-100' :src="item.app_logo" alt="">
                <div class="width80 ">
                  <p class="s_font_b fz-15 m-b-10 text-ac m-t-10">{{item.app_name}}</p>
                </div>
              </div>
            </div>
            <div class="height-121" style="border-left: 1px solid #D0D9E3;"></div>
            <div class="width23 s_flex_center">
              <div class="width60">
                <a-button type="primary" block v-has:orderAppsPay='()=>buyBnt({},1)'>续费</a-button>
              </div>
            </div>
        </div>
        <div v-if="list.length>0">
          <div class="p-25 s_bf4f s_bor10 s_flex_bian_c m-b-30" v-for='(item,index) in list' :key='index' v-show="item.is_get==0">
            <div class="width74 s_flex_bian_c">
              <img class='width-130 height-130' :src="item.app_logo" alt="">
              <div class="width80 m-r-25">
                <p class="s_font_b fz-18 m-b-10">{{item.app_name}} <span v-if="!item.is_get" style="font-size:14px;color:#999;padding:2px 10px;border:1px solid #999;display:inline-block;marginLeft:10px">未开通</span></p>
                <p>{{item.desc}}</p>
              </div>
            </div>
            <!-- v-if="info.overView.app_fees_type!=2" -->
            <div class="height-121" style="border-left: 1px solid #D0D9E3;" v-if="!item.is_get"></div>
            <!-- v-if="info.overView.app_fees_type!=2" -->
            <div class="width23 s_flex_center" >
              <div class="width60">
                <a-button type="primary" block v-has:orderAppsPay='()=>buyBnt(item,2)' v-if="!item.is_get">开通</a-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class='p-50'>
          <a-empty />
        </div>
      </a-spin>
    </div>
    <a-modal  :keyboard="false" title="立即购买" :width='1300' centered :footer="null" v-model:visible="showMore" destroyOnClose>
      <div style="overflow: hidden;">
        <p class="s_font_b fz-30 text-ac m-b-20">应用服务中心</p>
        <p class="text-ac s_mauto width60 fz-16">高大永恒塑料制品有限公司立足于服务品牌企业，利用数字化技术（大数据、云计算、人工智能等）来推动品牌企业商业模式、业务创新，营销传播，组织架构等方面的重塑，通过原生线下场景的大数据抓取、数据模型提炼，提升企业对数据的处理能力，提升效率，从而增加企业的经营效能。</p>
        <!-- <a-divider /> -->
        <!-- <div class="s_mauto width60 clearfix s_flex_center"> -->
        <a-form v-if="is_get!=0">
         <a-form-item label="续费年限：" required :wrapper-col="{ span: 8 }" :labelCol="{span:3}" style="marginTop:40px" class="fz-16">
          <a-select  placeholder="请选择"  v-model:value="renew_year"  @change="changeSelect">
            <a-select-option :value="item.valid_year" v-for="(item) in optionList" :key="item.valid_year">
                   {{item.valid_year_title}}
                 </a-select-option>
            </a-select>
        </a-form-item>
        </a-form>
        <div v-else style="display:flex;marginTop:40px;paddingLeft:10px" class="fz-16">
          <div class="xing">开通模块：</div>
          <div style="color:#999">{{dataMore.app_name}}</div>
        </div>

        <div style="display:flex;align-items: center;float:right;marginTop:50px">
          <div>本次费用合计：
            <span style="color:#e0001b;marginRight:60px">{{dataMore.price || 0}}元</span>
          </div>
           <a-button type="primary" v-has:orderAppsPayNow="buyNow">{{serviceItem.is_get?'立即续费':'立即开通'}}</a-button>
        </div>
          
          <!-- <img  style="width: 200px;height: 200px;margin-right:30px"  :src="dataMore.app_logo" alt="" v-if='info.overView.app_fees_type != 2 '>
          <div v-if='info.overView.app_fees_type == 2 ' class="scroll-view"  style="width: 200px;height: 200px;overflow-x:scroll;border:1px solid #eee;">
              <div :style="'width:'+list.length*200+'px;height:200px'" class="s_flex_center">
                <div  v-for='(item,index) in list' :key='index' class="s_flex_center s_flex_fdc" style="width: 200px;height: 200px;flex-shrink:0">
                  <img class='width-100 height-100' :src="item.app_logo" alt="">
                  <div class="width80 ">
                    <p class="s_font_b fz-15 m-b-10 text-ac m-t-10">{{item.app_name}}</p>
                  </div>
                </div>
              </div>
          </div> -->
          <!-- <div class="width57 p-l-30">
            <p class="s_font_b fz-18 m-b-15">{{dataMore.app_name}}</p>
            <p class="m-b-15" v-if='info.overView.app_fees_type == 2 && is_get==0'>
              产品价格
              <span class="theme_red s_font_b fz-18">{{sys_price}}</span>
              <span class="theme_red m-l-5">元</span>
            </p>
            <p class="m-b-15">
              {{info.overView.app_fees_type == 2 ?'服务费':'年限'}}
              <span class="theme_red s_font_b fz-18" v-if='info.overView.app_fees_type == 2 && is_get==0'>{{serve_price}}</span>
              <span class="theme_red m-l-5" v-if='info.overView.app_fees_type == 2 && is_get==0'>元</span>
            </p>
            <div class="m-b-15 s_flex_ali s_flex_wrap yearBox" v-if='info.overView.app_fees_type == 1'>
              <div class="width30 height-35 m-b-10 m-r-15 s_flex_center s_po_re s_over_h" :class='checkout == index ? "base_border":"s_bor_cd9"' v-for='(items,index) in dataMore.app_package' :key='index' @click='checkout = index;sys_price=dataMore.app_package[checkout].sys_price;sys_id=dataMore.app_package[checkout].id'>
                {{items.valid_year}}年
                <div class="s_po_ab gou" v-if='checkout == index'><span class="s_cfff">√</span></div>
              </div>
            </div>
            <div class="s_flex_ali s_flex_wrap yearBox" v-if='info.overView.app_fees_type == 2'>
              <div class="width30 height-35 m-b-10 m-r-15 s_flex_center s_po_re s_over_h base_border">
                1年
                <div class="s_po_ab gou"><span class="s_cfff">√</span></div>
              </div>
            </div>
            <p class="m-b-15 m-t-5">
              价格
              <span class="fz-18 s_font_b theme_red" v-if='info.overView.app_fees_type == 1&&dataMore.app_package'>{{dataMore.app_package[checkout].sys_price}}</span>
              <span class="fz-18 s_font_b theme_red" v-if='info.overView.app_fees_type == 2 && is_get'>{{dataMore.serve_price}}</span>
              <span class="fz-18 s_font_b theme_red" v-if='info.overView.app_fees_type == 2 && is_get==0'>{{Number(dataMore.serve_price)+Number(dataMore.sys_price)}}</span>
              <span class="theme_red m-l-5">元</span>
            </p>
            <a-button type="danger" @click="buyNow">{{info.overView.app_fees_type == 2?'立即续费':'立即购买'}}</a-button>
          </div> -->
        <!-- </div> -->
      </div>
    </a-modal>
  </a-layout>
</template>
<script>
import {  onMounted, inject, reactive, toRefs } from "vue";
import { getAppList, getAppDetail, appBuy, appRenewal,getAppDetailForServe,appsServeLists,appRenewInfo,appInfo,appsServeBuy,appRenewCountPrice,appsServeRenewal } from "@/api/orderApps";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import store from '@/store'
export default {
  setup() {
    const state = reactive({
      info: store.state.user.info,
      listLoading: false,
      list: [],
      app_id: "",
      is_get: 0,
      showMore: false,
      dataMore: {},
      serve_price: "",
      sys_price: "",
      sys_id: "",
      checkout: 0,
      renew_year:1,
      optionList:[],
      serviceItem:""
    });
    const buyBnt = async (e,type) => {
     state.serviceItem = e;
     state.dataMore={};
     if(type==1){ //续费
        state.renew_year = 1;
        state.is_get = 1;
        state.serviceItem.is_get = 1;
        await getAppListService()
        await  changeSelect(1) //价格
     }else{ //开通
       state.is_get = 0 ;
       await getAppInfo(e.id)
     }
     
      state.showMore = true;
    };
    const $router = inject("$router");
    const buyNow = async () => {
      let res;
          // 开通
            if (state.is_get == 0) {
              res = await appsServeBuy({ app_id:state.dataMore.id}).then((res) => res.data);
            } else { //续费
              res = await appsServeRenewal({ renew_year:state.renew_year }).then((res) => res.data);
            }
      if (iscode(res)) {
        $router.push("/orderApps/pay?order_no=" + res.data.order_no);
        state.showMore = false;
      } else {
        message.error(res.msg);
      }
    };
       console.log(state.info)

    //弃用
    const getMore = async () => {
       let res;
      if(state.info.overView.app_fees_type==2){
        res = await getAppDetailForServe({ app_id: state.app_id }).then(
        (res) => res.data
      );
      }else{
           res = await getAppDetail({ app_id: state.app_id }).then(
        (res) => res.data
      );
      }
    
      if (iscode(res)) {
        state.dataMore = res.data;
        if (res.data.app_package) {
          state.sys_price = res.data.app_package[0].sys_price;
          state.sys_id = res.data.app_package[0].id;
        }
        if (res.data.app_serve_fees) {
          state.serve_price = res.data.app_serve_fees[0].serve_price;
          state.sys_price = res.data.app_serve_fees[0].sys_price;
          state.sys_id = res.data.app_serve_fees[0].id;
        }
        state.showMore = true;
      } else {
        message.error(res.msg);
      }
    };

    const initData = async () => {
      state.listLoading = true;
      let res = await appsServeLists().then((res) => res.data);
      if (iscode(res)) {
        state.list = res.data;
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    };
    
    const is_getFun = function(){
      let arr = state.list.filter(item=>item.is_get==1);
      console.log(arr,111)
      return arr.length>0
    }

    //年费列表
   const getAppListService = async function(){
        let res = await appRenewInfo().then(res=>res.data);
          if (iscode(res)) {
            state.optionList = res.data || [];
          }else{
            message.error(res.msg);
          }
   }

   const getAppInfo = async function(id){
      let res = await appInfo(id).then(res=>res.data);
       if (iscode(res)) {
            // state.optionList = res.data || [];
            state.dataMore = res.data || {};
          }else{
            message.error(res.msg);
          }
   }

   //续费计算
   const changeSelect = async function(e){
     console.log('请示')
     state.renew_year = e;
     let res = await appRenewCountPrice({valid_year:state.renew_year}).then(res=>res.data);
      if (iscode(res)) {
         state.dataMore.price = res.data.price || 0;
      }else{
            message.error(res.msg);
       }
   }

    onMounted(() => {
      initData();
    });
    return {
      buyBnt,
      buyNow,
      getMore,
      ...toRefs(state),
      is_getFun,
      getAppListService,
      changeSelect
    };
  },
};
</script>
<style lang="less" scoped>
.yearBox p {
  border-radius: 3px;
}
.yearBox p:nth-child(3n) {
  margin-right: 0;
}
.gou {
  position: absolute;
  z-index: 1;
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  pointer-events: none;
  border: 10px solid #83c8dd;
  border-left-color: transparent;
  border-top-color: transparent;
  right: -1px;
  bottom: -1px;
}
.gou span {
  position: absolute;
  font-size: 12px;
  color: #fff;
  margin-top: 3px;
  transform: rotate(10deg);
}
.scroll-view{
  white-space: nowrap;
    &::-webkit-scrollbar {
    width: 0px;
    height: 5px;
    background-color: #fff;

}
}
.xing{
  position: relative;
  &::before{
    content: '*';
    color: red;
    margin-right:5px;
  }
}
</style>